import {
  VisualizationMetricsIndicator,
  VisualizationMetricsLevel,
} from "@/common/types";
import { cn } from "@/lib/utils";

interface MultiLevelProgressBarProps {
  levels: VisualizationMetricsLevel[];
  indicator: VisualizationMetricsIndicator;
}

const MultiLevelProgressBar: React.FC<MultiLevelProgressBarProps> = ({
  levels,
  indicator,
}) => {
  const totalValue = levels.reduce((sum, level) => sum + level.viz_value, 0);
  const indicatorPosition = (indicator.viz_value / totalValue) * 100;

  return indicatorPosition !== 0 ? (
    <div className={cn("w-full", "")}>
      <div className="relative h-5">
        <div
          className="absolute -translate-x-1/2 text-xs font-semibold"
          style={{ left: `${indicatorPosition}%` }}
        >
          {indicator.value}
        </div>
      </div>
      <div className="relative h-5 rounded-full overflow-hidden mb-1">
        {levels.map((level, index) => {
          const width = (level.viz_value / totalValue) * 100;

          return (
            <div
              key={index}
              className={cn(
                "absolute h-full flex items-center justify-center text-xs font-semibold text-white",
                "border-r border-white"
              )}
              style={{
                left: `${
                  (levels
                    .slice(0, index)
                    .reduce((sum, l) => sum + l.viz_value, 0) /
                    totalValue) *
                  100
                }%`,
                width: `${width}%`,
                backgroundColor: level.color,
              }}
            ></div>
          );
        })}
        <div
          className="absolute top-1/2 -translate-y-1/2 w-4 h-4 bg-white border-2 border-black rounded-full shadow-md"
          style={{ left: `${indicatorPosition}%` }}
          aria-hidden="true"
        />
      </div>
      <div className="flex gap-2 flex-wrap">
        {levels.map((level, index) => {
          return (
            <div key={index} className="flex items-center gap-1">
              <div
                className={`w-3 h-3 rounded-full`}
                style={{ backgroundColor: level.color }}
              ></div>
              <p className="text-xs">{level.label}</p>
              <p className="text-xs">{`(${level.value_lower} - ${level.value})`}</p>
            </div>
          );
        })}
      </div>
    </div>
  ) : (
    <div>
      <p>Value: {indicatorPosition}</p>
    </div>
  );
};

export default MultiLevelProgressBar;
